import { MutationTree } from "vuex";
import { EventLinksState, RetrievedEventLinks } from "./types";

export const mutations: MutationTree<EventLinksState> = {
	setEventLinksTable(state: EventLinksState, eventLinks: RetrievedEventLinks): void {
		state.eventLinkTableResponse = eventLinks;
	},
	setEventLinksList(state: EventLinksState, eventLinks: RetrievedEventLinks): void {
		state.eventLinkListResponse = eventLinks;
	}
};
